var render = function render(){
  var _vm$representativeTag;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "layer_pop_wrap"
  }, [_c('div', {
    staticClass: "layer_pop_dim",
    style: _vm.openBln ? 'display: flex; position: relative;' : 'display: none'
  }, [_c('div', {
    staticClass: "layer_pop lg editor dictionaryPopup",
    class: _vm.openBln ? 'active' : '',
    style: {
      left: `${_vm.positionX}%`,
      top: `${_vm.positionY}%`
    },
    attrs: {
      "data-role-popup": "modal_02",
      "tabindex": "0"
    },
    on: {
      "mousedown": _vm.startDragging,
      "mousemove": _vm.dragElement,
      "mouseup": _vm.stopDragging,
      "mouseleave": _vm.stopDragging
    }
  }, [_c('div', {
    staticClass: "pop_head"
  }, [_c('h2', [_vm._v(_vm._s(`${_vm.categoryToKoreaLang[_vm.category]}`) + " 사전 조회 및 수정")]), _c('button', {
    staticClass: "pop_close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickCloseHandler
    }
  }, [_vm._v("닫기")])]), _c('div', {
    staticClass: "pop_cont dictionaryPopup",
    staticStyle: {
      "padding-bottom": "10px"
    },
    on: {
      "mousedown": _vm.preventDrag
    }
  }, [_c('div', {
    staticClass: "layout_container dictionaryPopup"
  }, [!_vm.changeOnlyDisplayWord ? _c('div', {
    staticClass: "layout_item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "search_form_wrap"
  }, [_c('ul', {
    staticClass: "search_form_list"
  }, [_c('li', {
    style: _vm.searchList.length == 0 && !_vm.loading ? 'width: 90%;' : 'width: 100%;'
  }, [_c('div', {
    staticClass: "inpt_sch"
  }, [_c('input', {
    staticClass: "form_control",
    attrs: {
      "type": "text",
      "placeholder": "검색어를 입력하세요."
    },
    domProps: {
      "value": _vm.query
    },
    on: {
      "input": _vm.changeQuery,
      "keydown": _vm.inputEnter
    }
  }), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.search
    }
  })])]), _c('li', [_c('button', {
    staticClass: "sm_btn color_1",
    on: {
      "click": _vm.createDictionary
    }
  }, [_vm._v("신규등록")])]), _c('li', [_c('button', {
    staticClass: "sm_btn color_1",
    on: {
      "click": _vm.appendSimilarTag
    }
  }, [_vm._v("유사어등록")])])])]), _vm._m(0), _c('div', {
    staticClass: "tbl_wrap t_left dictionaryPopup"
  }, [_c('table', {
    ref: "mainDictionaryListFef",
    staticClass: "tbl_style2"
  }, [_vm._m(1), _vm.searchList.length > 0 ? _c('tbody', _vm._l(_vm.searchList, function (rowData, index) {
    return _c('tr', {
      key: index,
      staticClass: "border-bottom cursor-pointer",
      class: _vm.selectDictionaryId == rowData.dictionaryId ? 'selected' : null,
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.selectDictionary(rowData);
        }
      }
    }, [_c('td', {
      staticClass: "py-2 text-left",
      attrs: {
        "title": rowData.similarTagName
      }
    }, [_c('span', {
      staticClass: "ellipsis"
    }, [_vm._v(_vm._s(`${rowData.similarTagName}`))])]), _c('td', {
      staticClass: "py-2 text-left",
      attrs: {
        "title": rowData.representativeTagName
      }
    }, [_c('span', {
      staticClass: "ellipsis"
    }, [_vm._v(_vm._s(`* ${rowData.representativeTagName}`))])]), _c('td', {
      staticClass: "py-2 text-center"
    }, [_c('button', {
      staticClass: "sm_btn",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.addSimilarTag(rowData);
        }
      }
    }, [_vm._v("유사어등록"), _c('span', {
      staticClass: "icon-arrow-right"
    })])])]);
  }), 0) : _vm._e()])]), _c('table', {
    staticClass: "tbl_style2"
  }, [_vm._m(2), _vm.searchList.length == 0 && !_vm.loading ? _c('tbody', [_vm._m(3)]) : _vm._e()])]) : _vm._e(), _c('div', {
    staticClass: "layout_item",
    style: {
      'width': _vm.changeOnlyDisplayWord ? '100%' : '50%'
    }
  }, [_c('div', {
    staticClass: "view_cont"
  }, [_vm.similarTagList.length > 0 ? _c('ul', {
    staticClass: "column col_1"
  }, [_c('li', [_c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("대표어")]), !_vm.changeOnlyDisplayWord ? _c('button', {
    staticClass: "closeBtn dictionaryPopup",
    attrs: {
      "type": "button",
      "title": "사전선택취소"
    },
    on: {
      "click": _vm.resetSelectDictionary
    }
  }) : _vm._e()]), _c('div', [_vm._v(" " + _vm._s((_vm$representativeTag = _vm.representativeTag) === null || _vm$representativeTag === void 0 ? void 0 : _vm$representativeTag.tagName) + " ")])])]) : _vm._e(), _c('ul', {
    staticClass: "column col_1",
    staticStyle: {
      "max-height": "315px",
      "overflow-y": "scroll"
    }
  }, [_c('li', [_c('table', {
    ref: "detailDictionaryFef",
    staticClass: "tbl_style2"
  }, [_vm._m(4), _vm._m(5), _vm.similarTagList.length > 0 ? _c('tbody', _vm._l(_vm.similarTagList, function (tag, i) {
    var _vm$checkedTag;

    return _c('tr', {
      key: i,
      staticClass: "border-bottom cursor-pointer",
      class: ((_vm$checkedTag = _vm.checkedTag) === null || _vm$checkedTag === void 0 ? void 0 : _vm$checkedTag.tagId) == tag.tagId ? 'selected' : null,
      on: {
        "click": function ($event) {
          return _vm.clickSimilarTagList(tag, $event);
        }
      }
    }, [_c('td', {
      staticClass: "py-1 text-center border-right",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.checkedTag,
        expression: "checkedTag"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": tag,
        "checked": _vm._q(_vm.checkedTag, tag)
      },
      on: {
        "change": [function ($event) {
          _vm.checkedTag = tag;
        }, _vm.handleSelectionChange]
      }
    })]), _c('td', {
      staticClass: "py-1 text-center border-right"
    }, [_vm._v(" " + _vm._s(tag.representativeTagId == tag.tagId ? "대표어" : "유사어") + " ")]), _c('td', {
      staticClass: "py-1 text-center"
    }, [_vm._v(" " + _vm._s(tag.tagName) + " ")])]);
  }), 0) : _c('tbody', [_vm._m(6)])])])]), _vm.similarTagList.length > 0 ? _c('ul', {
    staticClass: "column col_1"
  }, [_c('li', [_c('div', {
    staticStyle: {
      "width": "100%",
      "display": "inline-block"
    }
  }, [(_vm.user.admin || _vm.user.committee) && !_vm.changeOnlyDisplayWord ? _c('button', {
    staticClass: "dictionary_btn",
    staticStyle: {
      "float": "left",
      "background-color": "palevioletred"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteDictionary
    }
  }, [_vm._v("사전삭제")]) : _vm._e(), _vm.crntObj.isSearchOption ? _c('button', {
    staticClass: "dictionary_btn",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.callSearchTagOption
    }
  }, [_vm._v("적용하기")]) : _c('button', {
    staticClass: "dictionary_btn",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.callModifyTagFunction
    }
  }, [_vm._v("적용하기")]), _c('button', {
    staticClass: "dictionary_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveDictionary
    }
  }, [_vm._v("사전저장")])])])]) : _vm._e()])])])])])]), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('table', {
    staticClass: "tbl_style2"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "35%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "35%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  })]), _c('thead', [_c('tr', [_c('th', [_vm._v(" 유사어 "), _c('button')]), _c('th', [_vm._v(" 대표어 ")]), _c('th', [_vm._v(" 수정/유사어추가 "), _c('button')])])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "35%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "35%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  })]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "35%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "35%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  })]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "nodata_txt"
  }, [_c('p', [_vm._v("결과를 찾을 수 없습니다."), _c('br'), _vm._v("우측 신규등록 버튼을 눌러 등록해 주세요.")])])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "15%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _c('col')]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("선택")]), _c('th', [_vm._v("분류")]), _c('th', [_vm._v("명칭")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "nodata_txt"
  }, [_c('p', [_vm._v("사전을 선택해주세요. ")])])])]);

}]

export { render, staticRenderFns }